
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { bool_type, list_type, class_type, option_type, union_type, record_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { PropertyConfiguration_$reflection } from "../../Shared/PropertyConfiguration.js";
import { ClientApiResponse$1_$reflection, PostResponse$1_$reflection, EmptyResponse_$reflection, FormState_$reflection, RequestedValue$1_$reflection } from "../../Shared/Shared.js";
import { DocumentFileCheck_DocumentFileCheckResponseDto_$reflection } from "../../Shared/Importer.js";

export class UploadedDocument extends Record {
    constructor(FileName, DocumentId) {
        super();
        this.FileName = FileName;
        this.DocumentId = DocumentId;
    }
}

export function UploadedDocument_$reflection() {
    return record_type("Importer.Document.Types.UploadedDocument", [], UploadedDocument, () => [["FileName", string_type], ["DocumentId", string_type]]);
}

export class FileCheckAttribute extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SerialNumber", "InventoryNumber", "CustomProperty"];
    }
}

export function FileCheckAttribute_$reflection() {
    return union_type("Importer.Document.Types.FileCheckAttribute", [], FileCheckAttribute, () => [[], [], [["Item", PropertyConfiguration_$reflection()]]]);
}

export class FileValidationStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotChecked", "CheckSuccessful", "CheckFailed"];
    }
}

export function FileValidationStatus_$reflection() {
    return union_type("Importer.Document.Types.FileValidationStatus", [], FileValidationStatus, () => [[], [["entityId", string_type], ["entityName", string_type], ["entityType", option_type(string_type)]], []]);
}

export class FileUploadStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotStarted", "Uploading", "Success", "Failed"];
    }
}

export function FileUploadStatus_$reflection() {
    return union_type("Importer.Document.Types.FileUploadStatus", [], FileUploadStatus, () => [[], [], [], []]);
}

export class SelectedFile extends Record {
    constructor(Id, File, ValidationStatus, UploadStatus) {
        super();
        this.Id = Id;
        this.File = File;
        this.ValidationStatus = ValidationStatus;
        this.UploadStatus = UploadStatus;
    }
}

export function SelectedFile_$reflection() {
    return record_type("Importer.Document.Types.SelectedFile", [], SelectedFile, () => [["Id", string_type], ["File", class_type("Browser.Types.File", undefined)], ["ValidationStatus", FileValidationStatus_$reflection()], ["UploadStatus", FileUploadStatus_$reflection()]]);
}

export class FileTableRow extends Record {
    constructor(Id, FileName, ValidationStatus, EntityId, EntityName, EntityType, UploadStatus) {
        super();
        this.Id = Id;
        this.FileName = FileName;
        this.ValidationStatus = ValidationStatus;
        this.EntityId = EntityId;
        this.EntityName = EntityName;
        this.EntityType = EntityType;
        this.UploadStatus = UploadStatus;
    }
}

export function FileTableRow_$reflection() {
    return record_type("Importer.Document.Types.FileTableRow", [], FileTableRow, () => [["Id", string_type], ["FileName", string_type], ["ValidationStatus", FileValidationStatus_$reflection()], ["EntityId", option_type(string_type)], ["EntityName", option_type(string_type)], ["EntityType", option_type(string_type)], ["UploadStatus", FileUploadStatus_$reflection()]]);
}

export class UploadStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotStarted", "Uploading", "Success", "Failed"];
    }
}

export function UploadStatus_$reflection() {
    return union_type("Importer.Document.Types.UploadStatus", [], UploadStatus, () => [[], [], [["Item", list_type(UploadedDocument_$reflection())]], [["Item", string_type]]]);
}

export class State extends Record {
    constructor(SelectedFiles, OriginSelectedFiles, UploadStatus, SelectedCheckAttribute, PropertyConfigurations, FormState, IsVisibleForUserRole) {
        super();
        this.SelectedFiles = SelectedFiles;
        this.OriginSelectedFiles = OriginSelectedFiles;
        this.UploadStatus = UploadStatus;
        this.SelectedCheckAttribute = SelectedCheckAttribute;
        this.PropertyConfigurations = PropertyConfigurations;
        this.FormState = FormState;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
    }
}

export function State_$reflection() {
    return record_type("Importer.Document.Types.State", [], State, () => [["SelectedFiles", list_type(SelectedFile_$reflection())], ["OriginSelectedFiles", list_type(SelectedFile_$reflection())], ["UploadStatus", UploadStatus_$reflection()], ["SelectedCheckAttribute", FileCheckAttribute_$reflection()], ["PropertyConfigurations", RequestedValue$1_$reflection(list_type(PropertyConfiguration_$reflection()))], ["FormState", FormState_$reflection()], ["IsVisibleForUserRole", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddFiles", "RemoveFile", "CheckDocumentFiles", "Upload", "FileUploadStarted", "FileUploadCompleted", "UploadCompleted", "SetCheckAttribute", "SetIsVisibleForUserRole", "PropertyConfigurationsFetched", "DocumentFileCheckCompleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Importer.Document.Types.Msg", [], Msg, () => [[["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", string_type]], [], [], [["Item", string_type]], [["Item1", string_type], ["Item2", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [], [["Item", FileCheckAttribute_$reflection()]], [["Item", bool_type]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", ClientApiResponse$1_$reflection(DocumentFileCheck_DocumentFileCheckResponseDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

